import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedUserResolverService, UserProfileMenuComponent } from '@aveva/connect-web-core';
import { ConnectAdminGuard } from './connect-admin.guard';
import { MaintenanceEditComponent } from './maintenance/maintenance-edit.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { LaunchComponent } from './launch/launch.component';
import { RootComponent } from './root/root.component';

const appRoutes: Routes = [
  {
    path: '',
    component: LaunchComponent,
    pathMatch: 'full'
  }
];

const childrenRoutes: Routes = [
  {
    path: 'maintenance',
    component: RootComponent,
    canActivate: [ConnectAdminGuard],
    resolve: {
      user: AuthenticatedUserResolverService
    },
    children: [
      {
        path : '',
        component: MaintenanceComponent
      },
      {
        path : ':solutionid/edit',
        component: MaintenanceEditComponent
      }
    ]
  },
  {
    path: 'account',
    component: RootComponent,
    resolve: {
      user: AuthenticatedUserResolverService
    },
    children: [
      {
        path: 'me',
        component: UserProfileMenuComponent,
        data: {
          redirectRoute: ['/maintenance']
        }
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
    useHash: true,
    onSameUrlNavigation: 'reload'
}
    ),
    RouterModule.forChild(childrenRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class AppRoutingModule { }
